import { combineReducers } from "redux";

// Authentication
import authentication from "./authentication/reducer";
import settings from "./settings/reducer";
import section from "./section/reducer";
import subscribers from "./subscribers/reducer";
import socialTypes from "./socialTypes/reducer";
import socials from "./socials/reducer";
import blogs from "./blogs/reducer";
import blogCategories from "./blogCategories/reducer";
import contactUs from "./contactUs/reducer";
import services from "./ourServices/reducer";
import works from "./ourWorks/reducer";

const rootReducer = combineReducers({
  authentication,
  section,
  services ,
  works ,
  settings,
  subscribers,
  socialTypes,
  socials,
  blogCategories,
  blogs,
  contactUs,
  
});

export default rootReducer;
